'use client'

import { CustomImageBanner } from '@/screens/promo-apipromo/ui/CustomImageBanner/CustomImageBanner'

import { PROMO_IPHONE_18_IMAGES_URL } from '../assets/images'

import cl from './HeroBanner.module.scss'

const block = {
	banners: {
		desktop: {
			src: `${PROMO_IPHONE_18_IMAGES_URL}/banner1-1440.webp`,
			link: ''
		},
		tablet: {
			src: `${PROMO_IPHONE_18_IMAGES_URL}/banner1-768.webp`
		},
		mobile: {
			src: `${PROMO_IPHONE_18_IMAGES_URL}/banner1-375.webp`
		}
	}
}

export const HeroBanner = () => {
	return (
		<section className={cl.root}>
			<CustomImageBanner
				fill
				imgAlt=""
				imgSrcDesk={block.banners.desktop.src}
				imgSrcTablet={block.banners.tablet.src}
				imgSrcMob={block.banners.mobile.src}
				imgDeskWidth={1440}
				imgDeskHeight={460}
				imgTabletWidth={768}
				imgTabletHeight={564}
				imgMobWidth={375}
				imgMobHeight={345}
				link={block.banners.desktop.link}
				disabled={!block.banners.desktop.link}
				title=""
			/>

			<div className={cl.content}>
				<p className={cl.model}>iPhone 18 Pro | Pro Max</p>
				<h1 className={cl.title}>Цвет решает</h1>
				<p className={cl.subtitle}>Оформи предзаказ сейчас</p>
			</div>
		</section>
	)
}
